import { LINK_FOR_NO_IMAGE } from "helpers/constans";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
interface Option {
  label: string;
  value: string;
}
interface DropdownPoolOptionProps {
  name?: string;
  initialValue?: Option | undefined | null;
  dataList?: Option[];
  onChangeSelect?: (params: Option) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  classNamePrefix?: string;
  isHasOptionAll?: boolean;
  optionAll?: undefined | Option;
  labelTop?: string;
  isMultiLang?: boolean;
  size?: 'normal' | 'big',
  isShowMore?: boolean
}

const DropdownPoolOption = ({
  name = "",
  initialValue,
  onChangeSelect,
  dataList = [],
  placeholder,
  disabled = false,
  className = "",
  classNamePrefix = "",
  isHasOptionAll = false,
  optionAll,
  labelTop = "",
  isMultiLang = false,
  size = 'normal',
  isShowMore = false
}: DropdownPoolOptionProps) => {
  const { t, i18n } = useTranslation();
  const [options, setOptions] = useState<Option[]>([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  useEffect(() => {
    const resultOptions: any =
      dataList?.map((item: any) => ({
        label: (
          <div className="d-flex align-items-center gap-2">
            <div
              style={{
                height: size === 'big' ? "32px" : '22px',
                width: size === 'big' ? "32px" : '22px',
                overflow: "hidden",
                borderRadius: size === 'big' ? "16px" : '15px',
                objectFit: "cover",
                backgroundColor: "#eaeaea",
                zIndex: 1,
                position: 'relative'
              }}
            >
              <img
                src={item?.logo1 || LINK_FOR_NO_IMAGE}
                alt={item?.label}
                // height={size === 'big' ? 32 : 22}
                // width={size === 'big' ? 32 : 22}
                style={{
                  minWidth: size === 'big' ? "32px" : "22px",
                  overflow: "hidden",
                  borderRadius: "50%",
                  objectFit: "cover",
                  backgroundColor: "#eaeaea",
                  width: '100%',
                  height: '100%'
                }}
              />
              {/* <img
                src={item?.logo2 || LINK_FOR_NO_IMAGE}
                alt={item?.label}
                height={size === 'big' ? 20 : 12}
                width={size === 'big' ? 20 : 12}
                style={{
                  minWidth: size === 'big' ? "20px" : "16px",
                  overflow: "hidden",
                  borderRadius: "50%",
                  objectFit: "cover",
                  backgroundColor: "#eaeaea",
                  position: 'absolute',
                  right: 0,
                  bottom: 0
                }}
              /> */}
            </div>
            <div>
              <div className={`${size === 'big' ? "fs-15" : "fs-12"}`}><strong>{item?.label || ''}</strong></div>
              {isShowMore && <div className={`text-muted ${size === 'big' ? 'fs-12' : 'fs-10'}`}>
                {item?.value?.slice(0, 8) + "..." + item?.value?.slice(-6)}
              </div>}
            </div>
          </div>
        ),
        value: String(item?.value || ""),
        data: item
      })) || ([] as Option[]);

    const result: any = isHasOptionAll ? [optionAll].concat(resultOptions) : resultOptions;
    setOptions((_prev: any) => result);

    if (initialValue?.value) {
      const val = result?.find((e: any) => e.value === initialValue?.value);
      setOnChangeOption(val);
    } else {
      setOnChangeOption(isHasOptionAll ? result[0] : null);
    }
  }, [JSON.stringify(dataList), JSON.stringify(initialValue?.value), i18n?.language]);

  const filterOption = (option: any, inputValue: any) => {
    const plainLabel = `${option.data?.label} ${option.data?.value}`;
    return plainLabel?.toLowerCase()?.includes(inputValue.toLowerCase());
  };

  return (
    <div className="position-relative" style={{ height: `${size === 'big' ? "47px" : "auto"}`, width: `${size === 'big' ? "230px" : "auto"}` }}>
      <Select
        options={options}
        value={initialValue}
        name={name}
        isDisabled={disabled}
        onChange={(e: any) => setOnChangeOption(e)}
        placeholder={<div>{placeholder || ""}</div>}
        loadingMessage={() => <div>{t("Loading")}...</div>}
        noOptionsMessage={() => <div>{t("No Options")}</div>}
        className={className}
        classNamePrefix={classNamePrefix}
        isClearable={false}
        filterOption={filterOption}
      // height={45}
      // style={{ outline: 'none' }}
      />
      {labelTop && (
        <label
          style={{
            position: "absolute",
            left: "5px",
            top: "0px",
            marginBottom: "0px",
            transform: "translateY(-50%)",
            padding: `0px 5px`,
            color: "#c2c2c2",
            fontSize: "12px",
            fontWeight: "400",
            borderRadius: "3px",
            backgroundColor: disabled
              ? "hsl(0, 0%, 95%)"
              : "var(--vz-secondary-bg)",
          }}
        >
          {isMultiLang ? t(labelTop) : labelTop}
        </label>
      )}
    </div>
  );
};

export default DropdownPoolOption;
